import { Constants } from '../../shared/Constants';

/**
 * Renders a badge HTML string from a badge mapping entry.
 * @param {{ txt?: any, theme?: string, icon?: string } | null} mapping
 * @param {*} data
 * @param {*} row
 * @returns {string}
 */
export function renderBadgeCell(mapping, data, row) {
    if (!mapping) return data == null ? '' : String(data);

    const iconHtml = mapping.icon ? `<i class="${mapping.icon} me-1"></i>` : '';
    let themeClass = mapping.theme || Constants.Theme.SECONDARY;
    const validThemes = Object.values(Constants.Theme);

    if (!validThemes.includes(themeClass)) {
        console.warn(`ColumnBuilder: Invalid theme "${themeClass}" in withBadge. Defaulting to secondary.`);
        themeClass = Constants.Theme.SECONDARY;
    }

    let resolvedText;
    if (typeof mapping.txt === 'function') {
        resolvedText = mapping.txt(data, row);
    } else if (mapping.txt != null && mapping.txt !== '') {
        resolvedText = mapping.txt;
    } else {
        resolvedText = data;
    }

    return `<span class="badge badge-${themeClass}">${iconHtml}${resolvedText ?? ''}</span>`;
}
